function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_youtube_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v10.5H0z",
  "data-name": "Rectangle 1040",
  style: {
    fill: "#fff"
  }
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-240 -1037)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  "data-name": "Rectangle 1017",
  rx: 14,
  style: {
    fill: "#c4c4c4"
  },
  transform: "translate(240 1037)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1291"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 86",
  style: {
    clipPath: "url(#icon_youtube_svg__a)"
  },
  transform: "translate(246.463 1045.591)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.687 1.64A1.88 1.88 0 0 0 13.36.313 45 45 0 0 0 7.5 0a45 45 0 0 0-5.86.313A1.88 1.88 0 0 0 .313 1.64 19.5 19.5 0 0 0 0 5.25a19.5 19.5 0 0 0 .313 3.61 1.88 1.88 0 0 0 1.327 1.327 45 45 0 0 0 5.86.313 45 45 0 0 0 5.86-.313 1.88 1.88 0 0 0 1.327-1.327A19.5 19.5 0 0 0 15 5.25a19.5 19.5 0 0 0-.313-3.61",
  "data-name": "Path 490",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m48.594 28.8 3.9-2.25-3.9-2.25z",
  "data-name": "Path 491",
  style: {
    fill: "#c4c4c4"
  },
  transform: "translate(-42.594 -21.297)"
})))));
export default SvgIconYoutube;